export const familyPlanSchemaVersion = 1;
function validText(value, maximum = 500) {
    return typeof value === "string" && value.trim().length > 0 && value.length <= maximum;
}
export function validateFamilyPlanSnapshot(value) {
    const issues = [];
    if (typeof value !== "object" || value === null)
        return { valid: false, issues: ["NOT_OBJECT"] };
    const snapshot = value;
    if (snapshot.schemaVersion !== familyPlanSchemaVersion)
        issues.push("INCOMPATIBLE_SCHEMA");
    const plan = snapshot.plan;
    if (typeof plan !== "object" ||
        plan === null ||
        !validText(plan.id, 100) ||
        !validText(plan.label, 120) ||
        plan.schemaVersion !== familyPlanSchemaVersion) {
        issues.push("INVALID_PLAN");
    }
    const contacts = snapshot.contacts;
    if (!Array.isArray(contacts))
        issues.push("INVALID_CONTACTS");
    else if (contacts.some((value) => {
        if (typeof value !== "object" || value === null)
            return true;
        const record = value;
        return (!validText(record.id, 100) ||
            !validText(record.planId, 100) ||
            !validText(record.name, 120) ||
            !validText(record.contactValue, 200));
    }))
        issues.push("INVALID_CONTACTS");
    const meetingPoints = snapshot.meetingPoints;
    if (!Array.isArray(meetingPoints))
        issues.push("INVALID_MEETING_POINTS");
    else if (meetingPoints.some((value) => {
        if (typeof value !== "object" || value === null)
            return true;
        const record = value;
        return (!validText(record.id, 100) ||
            !validText(record.planId, 100) ||
            !validText(record.label, 120) ||
            !validText(record.locationNote));
    }))
        issues.push("INVALID_MEETING_POINTS");
    const checklists = snapshot.checklists;
    if (!Array.isArray(checklists))
        issues.push("INVALID_CHECKLISTS");
    else if (checklists.some((value) => {
        if (typeof value !== "object" || value === null)
            return true;
        const record = value;
        const items = record.items;
        return (!validText(record.id, 100) ||
            !validText(record.title, 120) ||
            typeof record.kind !== "string" ||
            !["EVACUATION", "GO_BAG", "PET"].includes(record.kind) ||
            !Array.isArray(items) ||
            items.some((itemValue) => {
                if (typeof itemValue !== "object" || itemValue === null)
                    return true;
                const item = itemValue;
                return !validText(item.id, 100) || !validText(item.label, 200);
            }));
    }))
        issues.push("INVALID_CHECKLISTS");
    const protectedRecords = snapshot.protectedRecords;
    if (!Array.isArray(protectedRecords))
        issues.push("INVALID_PROTECTED_RECORDS");
    else if (protectedRecords.some((value) => {
        if (typeof value !== "object" || value === null)
            return true;
        const record = value;
        return (!validText(record.id, 100) ||
            !validText(record.planId, 100) ||
            typeof record.kind !== "string" ||
            !["MEMBER", "PET", "PRIVATE_NOTE"].includes(record.kind));
    }))
        issues.push("INVALID_PROTECTED_RECORDS");
    return { valid: issues.length === 0, issues };
}
